import {
  type DisplayDensity,
  sanitizeFontFamily,
} from "@/features/settings/stores/settingsStore";

/**
 * 表示設定をCSSカスタムプロパティ/DOM属性へ落とすための純関数群。
 * 反映処理そのものは routes/__root.tsx の useRenderSettings と
 * app/layouts/DesktopLayout が行う。
 */

/**
 * レス本文へ適用する font-family の値。未設定(既定)ならnullを返し、
 * 呼び出し側はカスタムプロパティを削除して本体既定のフォントへ戻す。
 */
export function resolvePostFontFamily(value: string): string | null {
  const fontFamily = sanitizeFontFamily(value);
  if (!fontFamily) return null;
  return `${fontFamily}, sans-serif`;
}

/**
 * .desktop-app に付ける data-density 属性値。
 * 既定(comfortable)では属性自体を付けず、現行の余白をそのまま使う。
 */
export function resolveDensityAttribute(
  value: DisplayDensity,
): "compact" | undefined {
  return value === "compact" ? "compact" : undefined;
}
